// extracted by mini-css-extract-plugin
export default {"ProjectCardDeck":"ProjectPage_ProjectCardDeck__6L6r7"};